/* Maqueta «estructura Salomon» — comportamiento de las secciones sa-* (FE, 2-oct-2026).
   Carrito real de Shopify (/cart/*.js), buscador predictivo, menú en cascada, cajones, carruseles con flechas y filtros. */
(function () {
  if (window.__saIniciado) return; window.__saIniciado = true;
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const R = window.SA.rutas;
  const SA = window.SA;
  const esc = s => String(s ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const img = (src, w) => src ? src + (src.includes('?') ? '&' : '?') + 'width=' + w : '';
  function dinero(cents) {
    const f = window.SA.moneda || '${{amount_no_decimals_with_comma_separator}}';
    const n = (cents || 0) / 100;
    const miles = (x, sep, dec, d) => { const [e, f2] = x.toFixed(d).split('.'); return e.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (d ? dec + f2 : ''); };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: miles(n, ',', '.', 2), amount_no_decimals: miles(n, ',', '.', 0),
      amount_with_comma_separator: miles(n, '.', ',', 2), amount_no_decimals_with_comma_separator: miles(n, '.', ',', 0)
    }[k] ?? miles(n, '.', ',', 0))).replace(/<[^>]+>/g, '').replace(/\s?COP$/, '');
  }

  /* ---------- cajones y menú ---------- */
  let hdr, transp = false;
  const alScroll = () => transp && hdr && hdr.classList.toggle('transparente', scrollY < 10 && !$('.menu.abierto,.buscar.abierto'));
  function cerrarTodo() {
    $$('.abierto').forEach(e => e.classList.remove('abierto'));
    $('.velo') && $('.velo').classList.remove('on'); document.body.style.overflow = '';
    $$('.menu .n2').forEach(n => n.hidden = true); $$('.menu .item.on').forEach(i => i.classList.remove('on'));
    alScroll();
  }
  function abrir(el) {
    if (!el) return; cerrarTodo(); el.classList.add('abierto'); $('.velo') && $('.velo').classList.add('on'); document.body.style.overflow = 'hidden';
    if (transp) hdr.classList.remove('transparente');
  }
  window.SA.abrir = abrir; window.SA.cerrarTodo = cerrarTodo;

  /* ---------- carrito ---------- */
  let cesta = { items: [], item_count: 0, total_price: 0 };
  async function leerCesta() { try { cesta = await (await fetch(R.carrito + '.js', { headers: { Accept: 'application/json' } })).json(); } catch (e) {} pintarCesta(); }
  function aviso(t) {
    const d = document.createElement('div'); d.textContent = t;
    d.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);background:#000;color:#fff;padding:12px 18px;border-radius:8px;z-index:9999;max-width:90%';
    document.body.appendChild(d); setTimeout(() => d.remove(), 2600);
  }
  async function agregar(id, props, q) {
    try {
      const r = await fetch(R.agregar + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [Object.assign({ id: +id, quantity: q || 1 }, props ? { properties: props } : {})] }) });
      if (!r.ok) { const j = await r.json(); aviso(j.description || SA.t.add_error); return; }
    } catch (e) { aviso(SA.t.add_error); return; }
    await leerCesta();
    document.body.dataset.page === 'cart' ? location.reload() : abrir($('#carrito'));
  }
  async function cambiar(linea, cantidad) {
    try { cesta = await (await fetch(R.cambiar + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: linea, quantity: cantidad }) })).json(); } catch (e) {}
    if (document.body.dataset.page === 'cart') return location.reload();
    pintarCesta();
  }
  function lineaHTML(it, i) {
    const op = (it.options_with_values || []).filter(o => o.value !== 'Default Title').map(o => esc(o.name) + ': ' + esc(o.value)).join(' · ');
    return `<div class="linea">
      <a href="${it.url}" class="foto"><img src="${img(it.image, 200)}" alt="" loading="lazy"></a>
      <div><div style="display:flex;justify-content:space-between;gap:12px"><a href="${it.url}" class="nom">${esc(it.product_title)}</a><span class="b">${dinero(it.final_line_price)}</span></div>
        <div class="meta">${op}</div>
        ${pre(it) ? `<div class="meta pre">${esc(SA.t.pre_order)} · ${esc(pre(it))}</div>` : ''}
        <div class="fila"><div class="cant"><button data-linea="${i + 1}" data-q="${it.quantity - 1}" aria-label="${esc(SA.t.remove_one)}">–</button><span>${it.quantity}</span><button data-linea="${i + 1}" data-q="${it.quantity + 1}" aria-label="${esc(SA.t.add_one)}">+</button></div>
        <button class="link" data-linea="${i + 1}" data-q="0">${esc(SA.t.remove)}</button></div></div></div>`;
  }
  const pre = it => it.properties && (it.properties['Preventa'] || it.properties['Pre-Order']);
  function pintarCesta() {
    const n = cesta.item_count || 0;
    $$('[data-n-cesta]').forEach(e => { e.textContent = n; n ? e.removeAttribute('data-cero') : e.setAttribute('data-cero', ''); });
    $$('[data-n-cesta-t]').forEach(e => e.textContent = n);
    const l = $('#carrito-lineas'); if (!l) return;
    l.innerHTML = cesta.items.length ? cesta.items.map(lineaHTML).join('') : (l.dataset.vacia || '');
    $('#carrito .pie-c').style.display = cesta.items.length ? '' : 'none';
    const nPre = cesta.items.filter(pre).length;
    let av = $('#carrito .aviso-envio');
    if (!av) { av = document.createElement('p'); av.className = 'aviso-envio'; av.style.cssText = 'background:#F8F2E7;padding:10px 12px;font-size:13px;line-height:19px;margin:0 0 12px'; $('#carrito .pie-c').prepend(av); }
    av.textContent = !nPre ? '' : nPre < cesta.items.length ? SA.t.ship_split : SA.t.ship_preorder;
    av.style.display = nPre ? '' : 'none';
    $('#carrito [data-subtotal]').textContent = dinero(cesta.total_price);
  }

  /* ---------- compra rápida ---------- */
  function hojaTalla(card) {
    const hoja = $('#hoja-talla'); if (!hoja || !card) return;
    const vs = JSON.parse(card.dataset.variantes || '[]');
    let elegida = vs.length === 1 && vs[0].ok ? vs[0].id : null;
    hoja.innerHTML = `<div class="cab"><span>${esc(SA.t.select_size)}</span><button data-cerrar aria-label="${esc(SA.t.close)}">✕</button></div>
      <p style="color:#6b6b6b">${esc(card.dataset.titulo)} · ${esc(card.dataset.precio || '')}</p>
      <div class="tallas">${vs.map(v => `<button class="talla ${v.id === elegida ? 'on' : ''}" ${v.ok ? '' : 'disabled'} data-v="${v.id}">${esc(v.t)}</button>`).join('')}</div>
      <button class="pill negra ancha" data-ok ${elegida ? '' : 'disabled'}>${esc(SA.t.add_to_bag)}</button>`;
    $$('[data-v]', hoja).forEach(b => b.addEventListener('click', () => { elegida = b.dataset.v; $$('[data-v]', hoja).forEach(x => x.classList.toggle('on', x === b)); $('[data-ok]', hoja).disabled = false; }));
    $('[data-ok]', hoja).addEventListener('click', () => elegida && agregar(elegida, card.dataset.preventa ? { 'Pre-Order': card.dataset.preventa } : null));
    abrir(hoja);
  }

  /* ---------- buscador ---------- */
  let tB;
  function buscar(q) {
    clearTimeout(tB);
    tB = setTimeout(async () => {
      const res = $('#q-res'); if (!res) return;
      if (q.trim().length < 2) { res.innerHTML = ''; return; }
      try {
        const j = await (await fetch(`${R.sugerir}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=12`)).json();
        res.innerHTML = (j.resources.results.products || []).map(p => `<article class="card"><a href="${p.url}" class="foto">${p.image ? `<img src="${img(p.image, 800)}" alt="" loading="lazy">` : ''}</a>
          <a href="${p.url}" class="nom">${esc(p.title)}</a><span class="precio">${dinero(Math.round(parseFloat(p.price) * 100))}</span></article>`).join('') || `<p>${esc(SA.t.no_results)}</p>`;
      } catch (e) {}
    }, 220);
  }

  /* ---------- ficha: colores hermanos (foto de cada color) ---------- */
  async function hermanos(cont) {
    const modelo = cont.dataset.modelo, tipo = cont.dataset.tipo, actual = cont.dataset.handle;
    try {
      const j = await (await fetch(`${R.sugerir}.json?q=${encodeURIComponent(modelo)}&resources[type]=product&resources[limit]=10`)).json();
      const mod = t => { const w = t.trim().split(/\s+/), s = ' ' + t + ' '; return ((s.includes(' Men ') || s.includes(' Women ')) ? w[0] : w[w.length - 1]).toLowerCase(); };
      const cand = (j.resources.results.products || []).filter(p => mod(p.title) === modelo.toLowerCase());
      const ps = await Promise.all(cand.map(p => fetch(p.url.split('?')[0] + '.js').then(r => r.json()).catch(() => null)));
      const vistos = new Set();
      const html = ps.filter(p => p && p.type === tipo).map(p => {
        const i = p.options.findIndex(o => /color/i.test(o.name)); const c = i >= 0 ? p.variants[0].options[i] : '';
        if (!c || vistos.has(c)) return ''; vistos.add(c);
        return `<a class="${p.handle === actual ? 'on' : ''}" href="/products/${p.handle}" title="${esc(c)}"><img src="${img(p.featured_image, 120)}" alt="${esc(c)}"></a>`;
      }).join('');
      if (vistos.size > 1) cont.innerHTML = html;
    } catch (e) {}
  }

  /* ---------- carruseles con flechas ---------- */
  function carrusel(root) {
    const cab = root.previousElementSibling, prev = cab && $('[data-prev]', cab), next = cab && $('[data-next]', cab);
    if (!prev || !root.children.length) return;
    const paso = () => root.children[0].getBoundingClientRect().width + 8;
    const est = () => { prev.disabled = root.scrollLeft < 4; next.disabled = root.scrollLeft + root.clientWidth >= root.scrollWidth - 4; };
    prev.addEventListener('click', () => root.scrollBy({ left: -paso() * 2 }));
    next.addEventListener('click', () => root.scrollBy({ left: paso() * 2 }));
    root.addEventListener('scroll', est, { passive: true }); est();
  }

  document.addEventListener('DOMContentLoaded', () => {
    hdr = $('.hdr'); transp = !!(hdr && hdr.classList.contains('transparente'));
    addEventListener('scroll', alScroll, { passive: true }); alScroll();
    addEventListener('keydown', e => e.key === 'Escape' && cerrarTodo());
    const q = $('#q'); q && q.addEventListener('input', () => buscar(q.value));

    document.addEventListener('click', e => {
      const a = e.target.closest('[data-abrir]');
      if (a) { if (a.dataset.abrir === 'carrito' && document.body.dataset.page === 'cart') return; e.preventDefault(); abrir($('#' + a.dataset.abrir)); if (a.dataset.abrir === 'buscar') setTimeout(() => q && q.focus(), 50); return; }
      if (e.target.closest('[data-cerrar]') || e.target.matches('.velo')) { cerrarTodo(); return; }
      const n2 = e.target.closest('[data-n2]');
      if (n2) { $$('.menu .n2').forEach(n => n.hidden = n.id !== n2.dataset.n2); $$('.menu [data-n2]').forEach(b => b.classList.toggle('on', b === n2)); return; }
      if (e.target.closest('[data-volver]')) { $$('.menu .n2').forEach(n => n.hidden = true); $$('.menu .item.on').forEach(i => i.classList.remove('on')); return; }
      const cj = e.target.closest('[data-cajon]'); if (cj) { e.preventDefault(); abrir($('#' + cj.dataset.cajon)); return; }
      const l = e.target.closest('[data-linea]'); if (l) { cambiar(+l.dataset.linea, +l.dataset.q); return; }
      const ad = e.target.closest('[data-add]'); if (ad) { e.preventDefault(); hojaTalla(ad.closest('[data-variantes]')); return; }
    });

    $$('.carrusel').forEach(carrusel);

    // Colección: ocultar filtros, vista, filtros que envían el formulario, «Ver más»
    const bf = $('#b-filtros');
    bf && bf.addEventListener('click', () => { const l = $('#listado'); l.classList.toggle('sin-filtros'); bf.textContent = l.classList.contains('sin-filtros') ? SA.t.show_filters : SA.t.hide_filters; });
    $$('[data-v-vista]').forEach(b => b.addEventListener('click', () => { $$('[data-v-vista]').forEach(x => x.classList.toggle('on', x === b)); $('#grilla').classList.toggle('compacta', b.dataset.vVista === 'compacta'); }));
    // Antes de enviar, los campos vacíos (precio desde/hasta) no viajan: «precio ≤ 0» dejaba la colección en cero.
    const limpiar = f => f.querySelectorAll('input[type=number]').forEach(i => { if (!i.value || +i.value <= 0) i.disabled = true; });
    $$('.filtro-form').forEach(f => f.addEventListener('submit', () => limpiar(f)));
    $$('.filtro-form').forEach(f => f.addEventListener('change', e => { if (e.target.matches('input[type=number]')) return; limpiar(f); f.submit(); }));
    $$('.filtro-form .talla input').forEach(i => i.closest('.talla').classList.toggle('on', i.checked));
    const mas = $('#b-mas');
    mas && mas.addEventListener('click', async e => {
      e.preventDefault(); const url = mas.getAttribute('href'); mas.classList.add('cargando');
      try {
        const doc = new DOMParser().parseFromString(await (await fetch(url)).text(), 'text/html');
        $$('#grilla > *', doc).forEach(n => $('#grilla').appendChild(n));
        const sig = $('#b-mas', doc), mo = $('#mostrando', doc);
        mo && ($('#mostrando').textContent = mo.textContent);
        sig ? mas.setAttribute('href', sig.getAttribute('href')) : mas.remove();
      } catch (err) { location.href = url; }
      mas.classList.remove('cargando');
    });

    // Ficha
    const ficha = $('[data-ficha]');
    if (ficha) {
      let variante = ficha.dataset.unica || null;
      const c = $('#comprar');
      $$('#tallas [data-v]').forEach(b => b.addEventListener('click', () => {
        variante = b.dataset.v; $('#t-sel').textContent = b.textContent; $('#t-sel').style.color = '';
        $$('#tallas [data-v]').forEach(x => x.classList.toggle('on', x === b));
        c.disabled = false; c.textContent = c.dataset.listo;
      }));
      const pre = ficha.dataset.preventa ? { 'Pre-Order': ficha.dataset.preventa } : null;
      // La cantidad elegida en «Lleva 2 / Lleva 3» (17-oct-2026); sin ese recuadro, 1.
      const cantVol = () => +(($('.vol-op.on') || {}).dataset || {}).vol || 1;
      c && c.addEventListener('click', () => variante && agregar(variante, pre, cantVol()));
      const cm = $('#comprar-m');
      cm && cm.addEventListener('click', () => variante ? agregar(variante, pre, cantVol()) : ($('#tallas').scrollIntoView({ behavior: 'smooth', block: 'center' }), $('#t-sel').style.color = '#b3261e'));
      const vf = $('#ver-fotos'); vf && vf.addEventListener('click', () => { $$('.galeria .oculta').forEach(x => x.classList.remove('oculta')); vf.remove(); });
      const gal = $('#galeria');
      gal && gal.addEventListener('scroll', () => { const w = gal.children[0].getBoundingClientRect().width + 8; const i = Math.round(gal.scrollLeft / w); $$('#puntos i').forEach((b, k) => b.classList.toggle('on', k === i)); }, { passive: true });
      $$('[data-hermanos]').forEach(hermanos);
    }

    // Pie: columnas abiertas en escritorio
    const mq = matchMedia('(min-width:768px)'); const pie = () => $$('.pie details').forEach(d => d.open = mq.matches); pie(); mq.addEventListener('change', pie);
    leerCesta();
  });
})();

/* 15-oct-2026: si la página termina en un bloque oscuro, el pie (también oscuro) se pega sin franja blanca */
(function () {
  function ultimo(el) {
    for (var c = el && el.lastElementChild; c; c = c.previousElementSibling) {
      if (/^(SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/.test(c.tagName)) continue;
      if (getComputedStyle(c).display === 'none') continue;
      return c;
    }
    return null;
  }
  function fondoFinal(el) {
    while (el) {
      var bg = getComputedStyle(el).backgroundColor;
      if (bg && bg !== 'transparent' && !/rgba\(\s*0,\s*0,\s*0,\s*0\s*\)/.test(bg)) return bg;
      el = ultimo(el);
    }
    return null;
  }
  function ajustar() {
    var main = document.getElementById('MainContent'), pie = document.querySelector('.pie');
    if (!main || !pie) return;
    var bg = fondoFinal(ultimo(main)), m = bg && bg.match(/\d+(\.\d+)?/g);
    if (!m) return;
    var lum = (0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2]) / 255;
    if (lum < 0.35) pie.style.marginTop = '0';
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', ajustar) : ajustar();
})();
